module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/coupons/coupons.component.css
// module id = ./src/app/coupons/coupons.component.css
// module chunks = main